"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("../../elements/button/Button");
var _buttonCarouselModule = _interopRequireDefault(require("./button-carousel.module.scss"));
var _buttonsToDisplay = _interopRequireDefault(require("../../utils/button-carousel/buttonsToDisplay"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["buttonKey", "buttonUrl", "buttonText", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  /** Array of objects containing button properties */
  buttonList: _propTypes["default"].arrayOf(_propTypes["default"].object),
  isCentred: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  hasLargeButtons: _propTypes["default"].bool
};
var defaultProps = {
  buttonList: [],
  isCentred: false,
  className: undefined,
  ariaLabel: undefined,
  hasLargeButtons: false
};
var ButtonCarousel = function ButtonCarousel(_ref) {
  var buttonList = _ref.buttonList,
    isCentred = _ref.isCentred,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    hasLargeButtons = _ref.hasLargeButtons;
  var TotalNumberOfButtons = buttonList.length;
  var ref = _react["default"].useRef();
  var _React$useState = _react["default"].useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isMobile = _React$useState2[0],
    setIsMobile = _React$useState2[1];
  var _React$useState3 = _react["default"].useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isExpanded = _React$useState4[0],
    setIsExpanded = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isReady = _React$useState6[0],
    setIsReady = _React$useState6[1];
  var _React$useState7 = _react["default"].useState(TotalNumberOfButtons),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    numberOfButtonsToShow = _React$useState8[0],
    setNumberOfButtonstoShow = _React$useState8[1];
  var numberHidden = TotalNumberOfButtons - numberOfButtonsToShow;
  var mobileUpper = 768;
  var updateIsMobile = function updateIsMobile() {
    setIsMobile(window.innerWidth < mobileUpper);
  };
  var findNextFocus = function findNextFocus(nextButton) {
    if (ref.current && ref.current.querySelector) {
      ref.current.querySelector("[data-ind=\"".concat(nextButton, "\"]")).focus();
    }
  };
  var updateNumberOfButtonsToShow = function updateNumberOfButtonsToShow() {
    var newButtonsWidths = [];
    var containerWidth = ref.current && ref.current.offsetWidth || 0;
    var anchorTags = ref.current && ref.current.querySelectorAll && ref.current.querySelectorAll('a:not([data-test^="show"]), button:not([data-test^="show"])');
    if (anchorTags) {
      anchorTags.forEach(function (element) {
        if (element) newButtonsWidths.push(element.offsetWidth);
      });
    }
    setNumberOfButtonstoShow((0, _buttonsToDisplay["default"])(newButtonsWidths, containerWidth));
  };
  var handleResize = (0, _debounce["default"])(function () {
    updateIsMobile();
    updateNumberOfButtonsToShow();
  });
  _react["default"].useLayoutEffect(function () {
    updateNumberOfButtonsToShow();
    updateIsMobile();
    setIsReady(true);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  _react["default"].useEffect(function () {
    updateNumberOfButtonsToShow();
  }, [buttonList]);
  _react["default"].useEffect(function () {
    if (isExpanded) {
      findNextFocus(numberOfButtonsToShow);
    } else if (isReady) findNextFocus(0);
  }, [isExpanded]);
  var buttonTag = function buttonTag(button, index) {
    var buttonKey = button.buttonKey,
      buttonUrl = button.buttonUrl,
      buttonText = button.buttonText,
      buttonClass = button.className,
      rest = _objectWithoutProperties(button, _excluded);
    var buttonProps = _objectSpread({
      href: buttonUrl,
      children: buttonText
    }, rest);
    if (!hasLargeButtons) buttonProps.size = 'responsive';
    var isHidden = !isMobile && !isExpanded && index + 1 > numberOfButtonsToShow;
    buttonProps.className = (0, _classnames3["default"])(buttonClass, _buttonCarouselModule["default"].button, _defineProperty(_defineProperty({}, _buttonCarouselModule["default"].hide, isHidden), _buttonCarouselModule["default"]['button--large'], hasLargeButtons));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, _objectSpread({
      "data-ind": index,
      inline: true
    }, buttonProps), buttonKey ? buttonKey : "button".concat(index));
  };
  return buttonList.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    "aria-label": ariaLabel || "Group of ".concat(TotalNumberOfButtons, " buttons"),
    className: (0, _classnames3["default"])(className, _buttonCarouselModule["default"].slider, _defineProperty(_defineProperty(_defineProperty({}, _buttonCarouselModule["default"].isCentred, isCentred), _buttonCarouselModule["default"].visibleSlider, isMobile), _buttonCarouselModule["default"].isReady, isReady)),
    children: [buttonList.map(function (button, index) {
      return buttonTag(button, index);
    }), !isMobile && !isExpanded && numberHidden > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      className: _buttonCarouselModule["default"].button,
      "data-test": "show-more",
      inline: true,
      "aria-label": "Show ".concat(numberHidden, " more"),
      onClick: function onClick() {
        setIsExpanded(true);
      },
      children: "+ ".concat(numberHidden)
    }), !isMobile && isExpanded && numberHidden > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      inline: true,
      "data-test": "show-less",
      className: _buttonCarouselModule["default"].button,
      onClick: function onClick() {
        setIsExpanded(false);
      },
      children: "Show less"
    })]
  });
};
ButtonCarousel.propTypes = propTypes;
ButtonCarousel.defaultProps = defaultProps;
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ButtonCarousel);